import TextArea, { TextAreaProps } from "antd/es/input/TextArea";

import "./styles.scss";

type CustomTextAreaType = TextAreaProps & {
  className?: string;
};

const CustomTextArea = ({ className, ...props }: CustomTextAreaType) => {
  return <TextArea className={`CustomTextArea ${className}`} {...props} />;
};

export default CustomTextArea;
